import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useMembership } from '../../../contexts/MembershipServiceContext';
import CheckoutForm from '../../../components/CheckoutForm';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';

const CheckoutPage = () => {
	const { t } = useTranslation('orderConfirmation');
	const { membershipListData } = useMembership();

	const { error: submitDataError, result: submitResult } = useSelector(
		(state) => state.customerDetailsSlice.postNewMembershipSignup
	);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				py: 2
			}}
		>
			{submitDataError && (
				<Alert variant='filled' severity='error' sx={{ mb: 3 }}>
					<AlertTitle>{t('errorTitle')}</AlertTitle>
					{t('errorCheckPayment')} <br />
					{t('errorContact', {
						email: membershipListData?.contactEmail || 'support@sempris.com'
					})}
					{submitResult?.transaction_id && (
						<Box
							component='span'
							sx={{ display: 'block', mt: 1, fontSize: '0.75rem' }}
						>
							{t('transactionId', {
								id: submitResult?.transaction_id
							})}
						</Box>
					)}
				</Alert>
			)}

			<CheckoutForm membershipListData={membershipListData} />
		</Box>
	);
};

export default CheckoutPage;
